export const steps = {
    default: "default",
    inviteTechnicalStaff: "inviteTechnicalStaff",
    editTechnicalStaff : "editTechnicalStaff",
    deleteTechnicalStaff: "deleteTechnicalStaff",
    successInviteTechnicalStaff : "successInviteTechnicalStaff",
    successEditTechnicalStaff:"successEditTechnicalStaff",
    successDeleteTechnicalStaff: "successDeleteTechnicalStaff"
}